import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { useIdentity } from "../../auth/useIdentity";
import { listDocuments } from "../../api/contact";
import type { PreviewDocuments } from "../../portal/preview";

/**
 * The documents guests open under Legal & Terms, for the previews: own or
 * inherited, as the portal shows them. Null while loading or when they cannot
 * be read (no grant, older radaccess) -- the preview then shows sample text.
 *
 * The Legal & Terms screen's query key and shape: one cache, so a document
 * saved there is what the preview shows here.
 */
export function useOperatorDocuments(ns: string): PreviewDocuments | null {
  const identity = useIdentity();
  const q = useQuery({
    queryKey: ["operatorDocuments", ns],
    enabled: Boolean(identity.token && ns),
    retry: false,
    queryFn: async () => (await listDocuments(identity, ns)).data.documents ?? [],
  });
  return useMemo(() => (q.data ? Object.fromEntries(q.data.map((d) => [d.kind, d.body])) : null), [q.data]);
}
